import { IncentiveDetail, IncentiveEnrolmentRecord, IncentiveItem } from "../types/incentive-types";
import { getQueryPath } from '../../../common/utils';
import { PaginateList } from "../../../common/types/common-types";
import { apiClient, apiErrorHandler, ADMIN_URL } from 'src/app/common/network';
import { Dispatch } from "react";

export type IncentiveListParams = {
  code: string;
  name: string;
  startDateFrom: Date | null;
  startDateTo: Date | null;
  endDateFrom: Date | null;
  endDateTo: Date | null;
  createdDateFrom: Date | null;
  createdDateTo: Date | null;
  status: string;
  type: string;
  isArchived: string;
  page: number;
  limit: number;
};

export const createNewIncentive = async (data: IncentiveDetail, dispatch?: Dispatch<any>): Promise<IncentiveDetail> => {
  return apiClient.post<IncentiveDetail>(`${ADMIN_URL}/incentive`, data, {
    headers: {
      "Content-Type": "application/json"
    }
  }).then(response => response.data)
    .catch(err => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const modifyIncentive = async (code: string, data: IncentiveDetail, dispatch?: Dispatch<any>): Promise<void> => {
  return apiClient.put<void>(`${ADMIN_URL}/incentive/${code}`, data, {
    headers: {
      "Content-Type": "application/json"
    }
  }).then(response => response.data)
    .catch(err => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const publishIncentive = async (code: string, dispatch?: Dispatch<any>): Promise<IncentiveDetail> => {
  return apiClient.post<IncentiveDetail>(`${ADMIN_URL}/incentive/${code}/publish`)
  .then(response => response.data)
    .catch(err => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const unpublishIncentive = async (code: string, dispatch?: Dispatch<any>): Promise<IncentiveDetail> => {
  return apiClient.post<IncentiveDetail>(`${ADMIN_URL}/incentive/${code}/unpublish`)
  .then(response => response.data)
    .catch(err => {
      throw apiErrorHandler(err, dispatch);
    });
}

export const uploadIncentiveCsvResult = async (file: File, code: string, resultDate: string, dispatch?: Dispatch<any>): Promise<void> => {
  var formData = new FormData();
  formData.append('file', file);
  formData.append('resultDate', resultDate);

  return apiClient.post<void>(`${ADMIN_URL}/incentive/${code}/upload-result`, formData)
  .then(response => response.data)
    .catch(err => {
      throw apiErrorHandler(err, dispatch);
    });
}

export const uploadIncentiveCsvResultByBlobId = async (submitData: any, code: string, dispatch?: Dispatch<any>): Promise<void> => {

  return apiClient.post<void>(`${ADMIN_URL}/incentive/${code}/upload-result-v2`, submitData)
  .then(response => response.data)
    .catch(err => {
      throw apiErrorHandler(err, dispatch);
    });
}

export const fetchIncentiveItem = async (code: string, dispatch?: Dispatch<any>): Promise<IncentiveDetail> => {
  return apiClient.get<IncentiveDetail>(`${ADMIN_URL}/incentive/${code}`)
    .then(response => response.data)
    .catch(err => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const fetchIncentiveList = async (params: IncentiveListParams, dispatch?: Dispatch<any>): Promise<PaginateList<IncentiveItem>> => {
  const queryPath = getQueryPath(`${ADMIN_URL}/incentive?`, params);
  return apiClient.get<PaginateList<IncentiveItem>>(queryPath)
    .then(response => response.data)
    .catch(err => {
      throw apiErrorHandler(err, dispatch);
    });

};

export const fetchIncentiveEnrolmentRecords = async (code: string, dispatch?: Dispatch<any>): Promise<IncentiveEnrolmentRecord[]> => {
  return apiClient.get<IncentiveEnrolmentRecord[]>(`${ADMIN_URL}/incentive/${code}/enrolment`)
    .then(response => response.data)
    .catch(err => {
      throw apiErrorHandler(err, dispatch);
    });
};
